import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { CloseIcon, FileIcon } from "components";

interface KbImportFileListProps {
  files: File[];
  onRemoveFile: (index: number) => void;
  disabled?: boolean;
}

export const KbImportFileList = ({
  files,
  onRemoveFile,
  disabled = false,
}: KbImportFileListProps) => {
  const theme = useTheme();

  if (files.length === 0) {
    return null;
  }

  return (
    <Stack
      sx={{
        gap: "8px",
        mt: "16px",
      }}
    >
      {files.map((file, index) => (
        <Stack
          key={`${file.name}-${index}`}
          direction="row"
          alignItems="center"
          sx={{
            gap: "12px",
            padding: "12px 16px",
            border: "1px solid",
            borderColor: theme.palette.neutral["015"],
            borderRadius: "8px",
            backgroundColor: theme.palette.neutral.main,
            transition: "all 0.2s ease",
            "&:hover": !disabled
              ? {
                  borderColor: theme.palette.neutral["020"],
                  backgroundColor: theme.palette.neutral["005"],
                }
              : {},
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "32px",
              height: "32px",
              flexShrink: 0,
            }}
          >
            <FileIcon type={file.type} width="24" height="24" />
          </Box>
          <Typography
            variant="body-small"
            sx={{
              flex: 1,
              color: theme.palette.lightBg.high,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {file.name}
          </Typography>
          {!disabled && (
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveFile(index);
              }}
              sx={{
                width: "24px",
                height: "24px",
                color: theme.palette.lightBg.medium,
                flexShrink: 0,
                "&:hover": {
                  color: theme.palette.error.main,
                  backgroundColor: theme.palette.error.tint,
                },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Stack>
      ))}
    </Stack>
  );
};
